import React from "react"
import { Modal } from "react-bootstrap"

import { commonErr } from "../common/errors"
import { cancelOrder, getCancelOrderReasons } from "../../model/car"

export default class CancelTrip extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            err: commonErr.INNIT,
            step: 0, //0 confirm 1: cancel trip 2: done
            errMsg: "",
            cancelReasons: null,
            ip_cancel_reason: "",
            ip_comment: ""
        }
    }
    componentDidMount() {
        getCancelOrderReasons(this.props.order.id).then(resp => {
                if (resp.data.error >= commonErr.SUCCESS) {
                        this.setState({
                                err: resp.data.error,
                                errMsg: resp.data.errorMessage,
                                cancelReasons: resp.data.data.reasons
                        });
                } else {
                        this.setState({
                                err: resp.data.error,
                                errMsg: resp.data.errorMessage
                        });
                }
        });
    }

    handleInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    goToCancelTrip() {
        this.setState({
            step: 1
        });
    }

    finishCancel() {
        this.props.hideModal();
        this.setState({
            step: 0,
            err: commonErr.INNIT
        });
        this.getOrder();
    }

    getOrder() {
        this.props.getOrder(this.props.order.id);
    }

    isValidCancelTrip() {
			if (!this.state.ip_cancel_reason || this.state.ip_cancel_reason === "" || this.state.ip_cancel_reason === "0") {
				return false;
			}
			if (this.state.ip_cancel_reason === "t0" && (!this.state.ip_comment || this.state.ip_comment === "")) {
					return false;
			}
			return true;
    }

    cancelTrip() {
        if (!this.isValidCancelTrip()) {
            this.setState({
                err: commonErr.FAIL,
                errMsg: "Vui lòng chọn lý do hoặc ghi rõ lý do của bạn."
            });
        } else {
            cancelOrder(this.props.uid, this.props.order.id, this.state.ip_cancel_reason, this.state.ip_comment).then(resp => {
                if (resp.data.error >= commonErr.SUCCESS) {
                    this.setState({
                        step: 2,
                        err: resp.data.error,
                        errMsg: resp.data.errorMessage
                    });
                } else {
                    this.setState({
                        step: 2,
                        err: resp.data.error,
                        errMsg: resp.data.errorMessage
                    });
                }
            });
        }
    }

 
    render() {
			var content;
			const { err, step, cancelReasons } = this.state;

        if (step === 2) {
            if (err >= commonErr.SUCCESS) {
                content = <div className="row form-default p-4">
                    <div className="line-form col-12">
                        <p className="text-center mb-4"><i className="ic ic-verify"></i> Huỷ chuyến thành công</p>
                    </div>
                    <div className="col-12 text-center">
                        <button className="btn btn-primary" type="button" onClick={this.finishCancel.bind(this)}>Hoàn tất</button>
                    </div>
                </div>
            } else {
				content = <div className="row form-default text-center p-4">
                    <div className="line-form col-12">
                        <p className="mb-4"><i className="ic ic-error"></i> Huỷ chuyến thất bại</p>
                    </div>
                    <div className="col-12 text-center">
                        <button className="btn btn-primary" type="button" onClick={this.goToCancelTrip.bind(this)}>Thử lại</button>
                    </div>
                </div>
            }
        } else if (step === 1) {
            content = <div className="form-default row p-3">
                <div className="col-12 form-group">
                    <select name="ip_cancel_reason" className="form-control" onChange={this.handleInputChange.bind(this)}>
                        <option selected disabled hidden>Vui lòng chọn lý do hủy chuyến</option>
                        {cancelReasons && cancelReasons.map(
                                reason => <option value={reason.reason}>{reason.desc}</option>
                        )}
                    </select>
                </div>
                <div className="col-12 form-group">
                    <input className="form-control" type="text" placeholder="Vui lòng nhập lời nhắn" name="ip_comment" onChange={this.handleInputChange.bind(this)} />
                </div>
                <div className="col-12 text-center">
                    <button className="btn btn-primary" type="button" name="cancelTripBtn" disabled={!this.isValidCancelTrip()} onClick={this.cancelTrip.bind(this)}>Huỷ chuyến</button>
                </div>
            </div>
        } else {
                content = <div className="row p-4">
                <div className="col-12 text-center">
                    <h5 className="font-strong mb-3">Bạn có chắc muốn huỷ chuyến?</h5>
                    <p className="">
                        Lưu ý: Bạn có thể mất phí khi huỷ chuyến. Vui lòng xem thêm tại chính sách huỷ chuyến của Mioto trong chi tiết chuyến.
                    </p>
                </div>
                <div className="col-12 text-center">
                    <button className="btn btn-primary" type="button" onClick={this.goToCancelTrip.bind(this)}>Tiếp tục</button>
                </div>
            </div>
          
        }

        return <Modal
            show={this.props.show}
            onHide={this.finishCancel.bind(this)}
            dialogClassName="modal-md"
            >
            <Modal.Header closeButton={true} closeLabel={""}>
                <Modal.Title>Huỷ chuyến</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {content}
            </Modal.Body>
        </Modal>
    }
}


// WEBPACK FOOTER //
// ./src/components/trip/canceltrip.js